import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const languages = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "pl", label: "Polski", flag: "🇵🇱" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
];

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const current = languages.find((l) => l.code === (i18n.language || "en")) || languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/70 bg-background-50 px-3 py-2 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100 cursor-pointer"
      >
        <span className="text-base leading-none">{current.flag}</span>
        <span>{current.label}</span>
        <span className="w-4 h-4 flex items-center justify-center">
          <i className={open ? "ri-arrow-up-s-line text-foreground-600" : "ri-arrow-down-s-line text-foreground-600"}></i>
        </span>
      </button>

      {open && (
        <div className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-1">
          {languages.map((l) => {
            const active = l.code === (i18n.language || "en");
            return (
              <button
                key={l.code}
                type="button"
                onClick={() => {
                  i18n.changeLanguage(l.code);
                  setOpen(false);
                }}
                className={`flex w-full items-center gap-2 rounded-md px-3 py-2 text-left text-sm transition-colors cursor-pointer ${
                  active
                    ? "bg-primary-100 font-semibold text-primary-900"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                <span className="text-base leading-none">{l.flag}</span>
                <span className="whitespace-nowrap">{l.label}</span>
                {active && (
                  <span className="ml-auto w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-primary-600"></i>
                  </span>
                )}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}